import { h } from 'preact';
import htm from 'htm';

const html = htm.bind(h);

export function SessionsScreen() {
    return html`
        <div id="sessions-screen" class="screen" style="display: none;">
            <h2>Session Moderation</h2>

            <div class="moderation-container">
                <div class="moderation-card">
                    <h3>Add Participants</h3>
                    <div class="form-group">
                        <label for="participant-name">Participant Name</label>
                        <div class="input-with-button">
                            <input type="text" id="participant-name" placeholder="Enter participant name" />
                            <button id="add-participant-btn" class="btn btn-primary">Add</button>
                        </div>
                    </div>

                    <div id="participants-list" class="participants-list">
                        <div class="empty-state">No participants added yet.</div>
                    </div>

                    <div class="moderation-actions">
                        <button id="organize-groups-btn" class="btn btn-primary" disabled>Organize into Groups</button>
                        <button id="clear-all-btn" class="btn btn-secondary" style="display: none;">Clear All</button>
                    </div>
                </div>

                <div id="groups-display" class="groups-display" style="display: none;">
                    <div class="groups-header">
                        <h3>Organized Groups</h3>
                        <button id="reset-groups-btn" class="btn-sm btn-secondary">Reset</button>
                    </div>
                    <div id="groups-container" class="groups-container"></div>
                </div>
            </div>
        </div>
    `;
}
